import React from 'react';
import toast from 'Shared/toast';
import { Modal, Row, Button, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import MessagePreview from 'App/components/Sms/MessagePreview';
import LaddaButton from '@/app/components/LaddaButton';
import FormButtonGroup from '@/app/components/styles/FormButtonGroup';
import useSendMassTextingMutation from '@/app/hooks/useSendMassTextingMutation';

const PaddedRow = styled(Row)`
    padding: 0.5% 0;
`;

const propTypes = {
    patientId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedTemplate: PropTypes.shape({
        value: PropTypes.string.isRequired,
        preview: PropTypes.shape({
            body: PropTypes.string.isRequired,
            footer: PropTypes.string.isRequired,
        }).isRequired,
    }),
};

const defaultProps = {
    selectedTemplate: null,
};

const SendOneTimeTextModal = ({ patientId, onClose, selectedTemplate }) => {
    const { mutateAsync, isLoading } = useSendMassTextingMutation(false);

    const message = `${selectedTemplate.preview.body} ${selectedTemplate.preview.footer}`;

    const onSend = async () => {
        try {
            await mutateAsync({
                message,
                selectedPatients: [patientId],
                queueReason: 'oneTime',
            });
            toast.success('Message sent successfully');
            onClose();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    return (
        <Modal show={selectedTemplate !== null} backdrop="static">
            <Modal.Header closeButton={false}>
                <Modal.Title role="heading" className="header">
                    Send One-Time Text
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PaddedRow>
                    <Col md={12}>
                        <MessagePreview message={message} />
                    </Col>
                    <Col md={12} style={{ paddingTop: '15px' }}>
                        Are you sure you want to send this text? <b>This will send immediately.</b>
                    </Col>
                </PaddedRow>
            </Modal.Body>
            <Modal.Footer>
                <FormButtonGroup>
                    <Button variant="outline-secondary" name="cancel" className="float-right" onClick={onClose}>
                        Cancel
                    </Button>
                    <LaddaButton
                        variant="primary"
                        name="send"
                        className="float-right"
                        onClick={onSend}
                        isLoading={isLoading}
                    >
                        Send
                    </LaddaButton>
                </FormButtonGroup>
            </Modal.Footer>
        </Modal>
    );
};

SendOneTimeTextModal.propTypes = propTypes;
SendOneTimeTextModal.defaultProps = defaultProps;

export default SendOneTimeTextModal;
